import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, OnInit, Signal } from '@angular/core';
import { AuthService, CustomerService } from '@libs/shared/auth';
import { FlashMessageModule, FlashMessageService, SpinnerOverlayService } from '@libs/shared/common';
import { CustomerModel } from '@libs/account/models';
import { TrackingGoogleService } from '@libs/shared/tracking';
import { CustomerAliasComponent } from './alias';
import { CustomerDetailsComponent } from './details';

@Component({
  selector: 'ui-account-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FlashMessageModule,
    CustomerDetailsComponent,
    CustomerAliasComponent,
  ],
})
export class CustomerComponent implements OnInit {
  private readonly authService: AuthService = inject(AuthService);
  private readonly customerService: CustomerService = inject(CustomerService);
  private readonly flashMessage: FlashMessageService = inject(FlashMessageService);
  private readonly trackingService: TrackingGoogleService = inject(TrackingGoogleService);
  private readonly spinnerOverlayService: SpinnerOverlayService = inject(SpinnerOverlayService);

  public readonly customerId: InputSignal<string | undefined> = input();
  public readonly customers: Signal<CustomerModel[] | undefined> = this.authService.allCustomers;
  public readonly customer: Signal<CustomerModel | undefined> = computed(() => {
    const customerId: string | undefined = this.customerId();
    const customers: CustomerModel[] | undefined = this.customers();

    return customers?.find(customer => customer.id === customerId);
  });


  public ngOnInit(): void {
    this.trackingService.trackAccountEvent('kundendaten', 'section-auswahl');
  }

  public onAliasSubmit(values: Partial<CustomerModel>): void {
    this.trackingService.trackAccountEvent('kundendaten', 'alias-speichern');
    this.spinnerOverlayService.showLoader();

    this.customerService.updateCustomer({
      id: this.customerId(),
      ...values,
    })
      .then(() => void this.flashMessage.showMessage('successCustomerAliasUpdate'))
      .catch(() => void this.flashMessage.showMessage('errorCustomerAliasUpdate'))
      .finally(() => void this.spinnerOverlayService.hideLoader());
  }
}
